import styled from "styled-components";

export const Container = styled.div`
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 80px;
	
	@media (max-width: ${({ theme }) => theme.breakpoints.s}px) {
		padding: 20px 0px;
		gap: 40px;
	}
`;

export const MainCard = styled.div`
	background-color: ${({ theme }) => theme.colors.white};
	border-radius: 8px;
	padding: 40px;
	width: 636px;
	max-width: 100%;
	display: flex;
	flex-direction: column;
	gap: 80px;
	align-items: center;
	box-shadow: 0px 1px 2px 0px rgba(24, 30, 45, 0.05),
    0px 0px 10px 0px rgba(64, 56, 95, 0.05),
    0px 0px 40px 0px rgba(81, 94, 108, 0.05);
	
	@media (max-width: ${({ theme }) => theme.breakpoints.l}px) {
		padding: 24px;
		gap: 40px;
		width: 100%;
		max-width: calc(100vw - 32px);
	}
`;

export const ContentContainer = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	gap: 56px;
	align-items: center;
	
	@media (max-width: ${({ theme }) => theme.breakpoints.s}px) {
		gap: 32px;
	}
`;

export const TextSection = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	gap: 24px;
	align-items: center;
`;

export const Title = styled.h1`
	font-family: "Archivo", sans-serif;
	font-weight: 700;
	font-size: 22px;
	line-height: 34px;
	color: ${({ theme }) => theme.colors.primary600};
	text-align: center;
	margin: 0;
	
	@media (max-width: ${({ theme }) => theme.breakpoints.s}px) {
		font-size: 18px;
		line-height: 28px;
	}
`;

export const CardsContainer = styled.div`
	width: 100%;
	display: flex;
	gap: 40px;
	align-items: flex-start;
	justify-content: center;
	
	@media (max-width: ${({ theme }) => theme.breakpoints.s}px) {
		flex-direction: column;
		gap: 24px;
		align-items: center;
	}
`;

export const AccountTypeCard = styled.div<{ selected?: boolean }>`
	display: flex;
	flex-direction: column;
	gap: 16px;
	align-items: center;
	cursor: pointer;
`;

export const CardInner = styled.div<{ selected?: boolean }>`
	background-color: ${({ theme }) => theme.colors.white};
	width: 180px;
	height: 180px;
	border-radius: 16px;
	display: flex;
	align-items: center;
	justify-content: center;
	border: ${({ selected, theme }) => 
		selected ? `3px solid ${theme.colors.primary300}` : `3px solid ${theme.colors.primary100}`
	};
	box-sizing: border-box;
	padding: ${({ selected }) => selected ? '10px' : '0'};
	color: ${({ selected, theme }) => 
		selected ? theme.colors.primary300 : theme.colors.primary300
	};
	
	@media (max-width: ${({ theme }) => theme.breakpoints.s}px) {
		width: 140px;
		height: 140px;
	}
`;

export const IconPlaceholder = styled.div`
	background-color: ${({ theme }) => theme.colors.secondary200};
	border-radius: 12px;
	width: 100px;
	height: 100px;
	
	@media (max-width: ${({ theme }) => theme.breakpoints.s}px) {
		width: 80px;
		height: 80px;
	}
`;

export const CardLabel = styled.p<{ selected?: boolean }>`
	font-family: "Inter", sans-serif;
	font-weight: ${({ selected }) => selected ? 500 : 500};
	font-size: 16px;
	line-height: 24px;
	color: ${({ selected, theme }) => 
		selected ? theme.colors.primary300 : theme.colors.netural800
	};
	text-align: center;
	margin: 0;
`;

export const ButtonGroup = styled.div`
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: space-between;
	
	@media (max-width: ${({ theme }) => theme.breakpoints.s}px) {
		flex-direction: column;
		gap: 16px;
		align-items: center;
	}
`;